export default __webpack_public_path__ + "static/media/music2.10c7e509.jpg";